import { StytchUIClient } from '@stytch/vanilla-js';
import { navigate } from '../router.ts';

export const stytch = new StytchUIClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN);

/**
 * Returns the current authenticated user,
 * or null if no user is authenticated [web:21][web:47]
 */
export function getCurrentUser() {
  return stytch.user.getSync();
}

export function logout() {
  stytch.session.revoke()
    .then(() => navigate('/login'))
    .catch(() => navigate('/login'));
}

export function navigateAfterLogin() {
  const redirect = localStorage.getItem('postLoginRedirect') || '/';
  localStorage.removeItem('postLoginRedirect');
  navigate(redirect);
}

export function getJwt() {
  return stytch.session?.getTokens()?.session_jwt;
}
